import { respondTo } from 'assets/styled/breakpoints';
import { orderFlowLayoutVars } from 'components/OrderNavigation/OrderNavigation.styled';
import styled, { css } from 'styled-components';

interface StyledProps {
  hasSubHeader: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 100%;
  align-self: center;
  position: relative;
  ${(props: StyledProps) => orderFlowLayoutVars(props.hasSubHeader)}
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1440rem;
  margin: 100rem auto 0;
  padding-bottom: 30rem;

  ${respondTo.smallLaptop`
    margin-top: 50rem;
    padding: 50rem 15rem;
  `}

  ${respondTo.smallTablet`
    margin-top: 60rem;
    padding: 20rem 15rem;
  `}

  ${(props: StyledProps) =>
    props.hasSubHeader &&
    css`
      padding-top: 0 !important;
      margin-top: 0 !important;
    `}
`;

export const AbsoluteWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  pointer-events: none;
  user-select: none;
`;
